import React from 'react'
import { Text, TextInputProps } from 'react-native'

import { B1, B2, Input, SH3, Stack, XStack } from '@zet/design-system'
import { DEVICE_WIDTH } from '@zet/utils/Constants'

type MobileInputProps = {
  label: string
  placeholder?: string
  onChange?: (value: string) => void
  onBlur?: () => void
  value?: string
  isRequired?: boolean
  isEditable?: boolean
  iconLeft?: React.ReactNode
  className?: string
  disabled?: boolean
  inputMode?: TextInputProps['inputMode']
  config?: {
    maxLength?: number
  }
  noDisabledStyle?: boolean
  errorMessage?: string
  countryCode?: string
}

export const MobileInput: React.FC<MobileInputProps> = ({
  label,
  placeholder,
  onChange = () => null,
  onBlur,
  value,
  isRequired = true,
  isEditable,
  iconLeft,
  className,
  disabled,
  inputMode,
  config,
  noDisabledStyle,
  errorMessage,
  countryCode,
}) => {
  return (
    <Stack>
      <B2 className="text-grays-80 mb-1">
        {label} {isRequired && <B1 className="text-error-100 ml-1">*</B1>}
      </B2>
      <XStack
        className={`
        border-grays-40 w-full overflow-hidden rounded-md border px-2 py-[12px]
        ${disabled && !noDisabledStyle ? 'bg-grays-30' : ''}
        ${errorMessage ? 'border-error-100' : ''}
      `}
      >
        {countryCode && (
          <SH3 className="text-grays-80 border-grays-40 self-center border-r-[1px] px-2">
            {countryCode}
          </SH3>
        )}
        <Input
          placeholder={placeholder}
          onBlur={onBlur}
          onChangeText={(value) => {
            if (value.length <= 10) onChange(value)
          }}
          className={`
             m-0 h-full flex-1 border-0 bg-black bg-transparent px-0 pl-2 font-[Graphie-SemiBold] leading-5 outline-none
              ${className || ''}
            `}
          value={value}
          intent={errorMessage ? 'error' : 'primary'}
          type={errorMessage ? 'error' : 'primary'}
          isEditable={isEditable}
          iconLeft={iconLeft}
          style={{
            paddingLeft: 8,
            paddingVertical: 0,
            width: DEVICE_WIDTH * 0.7,
          }}
          inputMode={inputMode}
          keyboardType={'number-pad'}
          noIconPadding={true}
          disabled={disabled}
          maxLength={config?.maxLength}
        />
      </XStack>
      {errorMessage && <ErrorText intent="error">{errorMessage}</ErrorText>}
    </Stack>
  )
}

type ErrorTextProps = {
  children: React.ReactNode
  intent?: 'error' | 'default'
}

const ErrorText: React.FC<ErrorTextProps> = ({
  children,
  intent = 'default',
}) => (
  <Text
    className={`
    pt-2 text-xs font-normal leading-4
    ${intent === 'error' ? 'text-error-100' : 'text-grays-60'}
  `}
  >
    {children}
  </Text>
)
